import { ImportedInvoiceDocument } from '@features/importedInvoices/types/importedInvoiceDocument'
import { getImportedInvoiceIntegrationStatus } from '@features/importedInvoices/utils/getImportedInvoiceIntegrationStatus'

import { ImportedInvoicesTableRow } from '../types/importedInvoicesTableRow'

export const getImportedInvoicesTableData = (documents: ImportedInvoiceDocument[]): ImportedInvoicesTableRow[] =>
  documents.map((document) => ({
    // The imported-invoice id: the DS `TableData` key and the drawer's URL key.
    id: String(document.id),
    fileName: document.filename ?? '',
    integrationRejectCode: document.status?.cpaToolsIntegrationRejectCode ?? undefined,
    integrationStatus: getImportedInvoiceIntegrationStatus(document.status?.cpaToolsIntegrationStatus),
    uploadDate: document.uploadDate ?? '',
  }))
